<article class="chart-card donut-card">
  <header class="card-header">
    <h3 class="card-title">{{ title() }}</h3>
  </header>

  <div class="chart-row">
    <div class="chart-wrap"
         [style.width.px]="viewWidth()"
         [style.height.px]="viewHeight()"
    >

      <app-donut-chart
        [data]="donutData()"
        [customColors]="donutColors()"
        [showLegend]="false"
        [arcWidth]="arcWidth()"
        [view]="viewTuple()">
      </app-donut-chart>


      @if (overlayLabels().length) {
        <div class="labels-layer">
          @for (lbl of overlayLabels(); track $index) {
            <span class="overlay-label"
                  [style.left.px]="lbl.x"
                  [style.top.px]="lbl.y"
                  [style.color]="lbl.fill">
              {{ lbl.text }}
            </span>
          }
        </div>
      }
    </div>

    @if (showLegend() && legendItems().length) {
      <ul class="legend legend--right" aria-label="Leyenda de segmentos">
        @for (it of legendItems(); track trackByLegend($index, it)) {
          <li class="legend__item">
            <span class="legend__dot" [style.background]="it.color" aria-hidden="true"></span>
            <span class="legend__label">{{ it.label }}</span>
          </li>
        }
      </ul>
    }
  </div>
</article>
